<template>
    <div>
        <p v-html="safeSurveyDesc" v-linkified:options="linkifiedOptions"/>
        <template v-for="image in images">
            <img :src="image.url" alt="" @click="onClickPreviewImage(image.url)">
        </template>
    </div>
</template>

<script>
import linkify from 'vue-linkify';
import {getSafeHtml} from '@/common/utils/safeHtml.js';
import {htmlEntitiesDecode} from '@/common/utils/htmlEntities.js';

export default {
    name: 'ResponseDescText',
    directives: {
        linkified: linkify,
    },

    props: {
        surveyDesc: {
            type: String,
            required: true,
        },

        images: {
            type: Array,
        },
    },

    computed: {
        safeSurveyDesc() {
            return getSafeHtml(this.surveyDesc);
        },

        linkifiedOptions() {
            return {
                nl2br: true,
                formatHref: (href, type) => {
                    // decode html entity
                    return htmlEntitiesDecode(href);
                },
                target: () => {
                    return '_blank';
                },
                validate: {
                    url: function (value) {
                        return /^https?:\/\//.test(value);
                    },
                },
            };
        },
    },

    methods: {
        onClickPreviewImage(url) {
            window.open(url);
        },
    },
};
</script>

<style scoped>

</style>
